<template>
<div style="max-height: 325px; min-height: 325px" >
  <div class="row mb-2">
    <div class="col-md-12 text-right">
       <button type="button" class="btn btn-success btn-rounded mb-2 mr-2 btn-sm" @click="newTicket()">
          <i class="mdi mdi-plus mr-1"></i> Criar Ingresso
        </button>
      <br />
    </div>
    <!-- end col-->
  </div>
  <div class="table-responsive" v-if="symplatickets.length > 0">
    <table class="table table-centered table-nowrap table-hover">
      <thead>
        <tr>
          <th width="90%">Descrição</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(list, idx) in symplatickets" :key="idx" class="link">
          <td @click="editReward(list.id)">{{ list.name }}</td>
          <td>
            <i class="fas fa-trash-alt text-danger mr-1" title="Excluir" @click="deleteTicket(list.id)"></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row" v-if="symplatickets.length > perPage">
    <div class="col">
      <div class="dataTables_paginate paging_simple_numbers float-right">
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="getTickets"></b-pagination>
        </ul>
      </div>
    </div>
  </div>
  <event-modal v-model="modalForm" ref="formTicket" @createdTicket="getTickets()"></event-modal>
</div>
</template>
<script>
import Swal from 'sweetalert2'
import EventModal from './Form'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    EventModal
  },
  name: 'sympla-events',
  data () {
    return {
      loading: true,
      modalForm: false,
      totalRows: 1,
      currentPage: 1,
      idTicket: null,
      perPage: 4
    }
  },
  mounted () {
    this.getTickets()
    this.totalRows = this.ticketpagination.total
    this.currentPage = this.ticketpagination.current_page
    this.loading = false
  },
  computed: {
    ...mapState('sympla', ['symplatickets', 'ticketpagination']),
    rows () {
      return this.ticketpagination.total
    }
  },
  methods: {
    ...mapActions('sympla', {
      getAll: 'getAll',
      deleteItem: 'deleteTicket'
    }),
    newTicket () {
      this.$refs.formTicket.open('')
      this.modalForm = true
    },
    editTicket (id) {
      this.$refs.formTicket.open(id)
      this.modalForm = true
      this.idTicket = id
    },
    deleteTicket (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.deleteItem(id).then((data) => {
              successMessage(data.data.message, 2500)
              this.getTickets()
            }).catch(error => {
              errorMessage('Alerta: ' + error.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getTickets () {
      let loeader = this.$loading.show()
      let params = {
        limit: this.perPage,
        page: this.currentPage
      }
      this.params = params
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.ticketpagination.total
        this.currentPage = this.ticketpagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    }
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 300px;}
.float-sm-end { float: right }
</style>
